(() => {
  if (window.PMPUxRuntime) return;
  const contextElement = document.getElementById('pmp-ux-context');
  if (!contextElement) return;
  let context;
  try { context = JSON.parse(contextElement.textContent); } catch { return; }
  if (context.type === 'collection') {
    const focus = context.family === 'parasites' || ['parasites', 'worms'].includes(context.need) ? 'parasite-support' : context.family === 'yeast' ? 'yeast-support' : '';
    if (focus) document.querySelectorAll('main a[href*="/products/dog-yeast-infection-treatment"]').forEach(link => {
      const target = new URL(link.href, location.origin);
      target.hash = focus;
      link.href = target.toString();
    });
  }
  if (context.type === 'collection') document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href*="/products/dog-yeast-infection-treatment"]');
    if (!link) return;
    if (context.family === 'parasites' || ['parasites', 'worms'].includes(context.need)) link.hash = 'parasite-support';
    else if (context.family === 'yeast') link.hash = 'yeast-support';
  }, { capture: true });
  const abort = new AbortController();
  const diagnostics = document.createElement('output');
  diagnostics.id = 'pmp-ux-diagnostics';
  diagnostics.hidden = true;
  diagnostics.dataset.preview = String(context.preview);
  document.body.append(diagnostics);
  const observed = [];
  window.PMPUxRuntime = { context, observed };
  const allowedHost = ['www.puremajestypet.com', 'puremajestypet.com'].includes(location.hostname);
  const consent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    try { return privacy?.analyticsProcessingAllowed?.() === true; } catch { return false; }
  };
  const cleanPath = (href) => {
    try { const url = new URL(href, location.origin); return url.origin === location.origin ? url.pathname : ''; } catch { return ''; }
  };
  const params = {
    content_group: context.family,
    content_cluster: context.family,
    content_type: context.type,
    content_need: context.need,
    page_market: context.market,
    page_language: context.language,
    site_hostname: location.hostname,
    source_path: context.page_path
  };
  function send(name, extra = {}) {
    const event = { name, ...params, ...extra };
    if (context.preview) {
      observed.push(event);
      if (observed.length > 30) observed.shift();
      diagnostics.textContent = JSON.stringify(observed);
      diagnostics.dataset.lastEvent = name;
      return;
    }
    if (!allowedHost || !consent()) return;
    if (typeof window.gtag === 'function') window.gtag('event', name, { ...params, ...extra });
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }
  let labeled = false;
  function labelContext() {
    if (context.preview || !allowedHost || !consent() || labeled) return;
    labeled = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'pmp_content_context', ...params });
    if (typeof window.gtag === 'function') window.gtag('set', 'content_group', context.family);
    send('pmp_content_view');
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'content_cluster', context.family);
      window.clarity('set', 'content_type', context.type);
      window.clarity('set', 'page_market', context.market);
      window.clarity('set', 'page_language', context.language);
    }
  }
  function focusPanel(scroll = false) {
    const root = document.querySelector('[data-pmp-yeast-focus]');
    if (!root) return;
    const selection = location.hash === '#parasite-support' ? 'parasite' : 'yeast';
    root.querySelectorAll('[data-pmp-focus-panel]').forEach(panel => {
      panel.open = panel.dataset.pmpFocusPanel === selection;
    });
    root.querySelectorAll('[data-pmp-focus]').forEach(link => {
      link.classList.toggle('is-active', link.dataset.pmpFocus === selection);
      if (link.dataset.pmpFocus === selection) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-pmp-focus-reading]').forEach(panel => { panel.hidden = panel.dataset.pmpFocusReading !== selection; });
    params.content_focus = selection;
    if (!context.preview && allowedHost && consent() && typeof window.clarity === 'function') window.clarity('set', 'content_focus', selection);
    if (scroll) root.querySelector('[data-pmp-focus-panel="' + selection + '"]')?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  }
  document.addEventListener('click', event => {
    const focus = event.target.closest?.('[data-pmp-focus]');
    if (focus) send('product_focus_click', { focus: focus.dataset.pmpFocus, content_focus: focus.dataset.pmpFocus });
    let link = event.target.closest?.('[data-pmp-ux]');
    let legacyPosition = '';
    if (!link) {
      const candidate = event.target.closest?.('.blog-post-content a[href*="/products/"]');
      if (!candidate) return;
      link = candidate;
      const region = candidate.closest('.blog-post-content');
      const distance = candidate.getBoundingClientRect().top - region.getBoundingClientRect().top;
      const fraction = distance / Math.max(region.getBoundingClientRect().height, 1);
      legacyPosition = fraction < .25 ? 'top' : fraction > .75 ? 'bottom' : 'middle';
    }
    const destination = cleanPath(link.href);
    if (!destination) return;
    send(link.dataset.pmpUx === 'cta' || legacyPosition ? 'cta_click' : 'navigation_click', {
      link_type: link.dataset.pmpUx || 'product',
      cta_position: legacyPosition || link.dataset.pmpPosition || 'other',
      destination_path: destination
    });
  }, { signal: abort.signal });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-pmp-ingredients]') && event.target.open) send('ingredients_open', { cta_position: 'product_intro' });
    if (event.target.matches?.('[data-pmp-research]') && event.target.open) send('research_open', { cta_position: 'product_intro' });
  }, { capture: true, signal: abort.signal });
  const milestones = new Set();
  const article = document.querySelector('.blog-post-content');
  const sticky = document.querySelector('[data-pmp-article-sticky]');
  const choice = document.querySelector('[data-pmp-article-choice]');
  let scheduled = false;
  function readProgress() {
    scheduled = false;
    if (article) {
      const rect = article.getBoundingClientRect();
      const progress = Math.max(0, Math.min(100, (window.innerHeight - rect.top) / Math.max(rect.height, 1) * 100));
      for (const threshold of [25, 50, 75]) {
        if (progress >= threshold && !milestones.has(threshold)) {
          milestones.add(threshold);
          send('content_scroll', { percent_scrolled: threshold, scroll_scope: 'article' });
        }
      }
    }
    if (sticky && choice) {
      const past = choice.getBoundingClientRect().bottom < 0;
      const footerVisible = document.querySelector('footer')?.getBoundingClientRect().top < window.innerHeight;
      sticky.hidden = !past || Boolean(footerVisible);
    }
  }
  window.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(readProgress); }
  }, { passive: true, signal: abort.signal });
  window.addEventListener('hashchange', () => focusPanel(true), { signal: abort.signal });
  document.addEventListener('shopify:section:load', () => { focusPanel(); readProgress(); }, { signal: abort.signal });
  document.addEventListener('visitorConsentCollected', labelContext, { signal: abort.signal });
  window.addEventListener('pmp:cart-added', event => {
    send('pmp_cart_added', { item_id: String(event.detail?.variant_id || context.product_id), quantity: Number(event.detail?.quantity || 1) });
    if (!context.preview && allowedHost && consent() && typeof window.clarity === 'function') window.clarity('event', 'add_to_cart');
  }, { signal: abort.signal });
  document.addEventListener('click', event => {
    if (event.target.closest?.('a[href*="/checkout"], [data-pmp-checkout], [name="checkout"], [name="pmp-buy-now"]')) {
      send('checkout_click', { cta_position: 'checkout' });
    }
  }, { signal: abort.signal });
  window.addEventListener('pagehide', () => abort.abort(), { once: true });
  focusPanel();
  labelContext();
  readProgress();
})();

